import { Box, BoxProps } from '@ttoss/ui';

const HorizontalLine = ({ sx, ...props }: BoxProps) => {
  return (
    <Box
      as="hr"
      sx={{
        borderTop: 'solid 2px',
        borderTopColor: 'muted',
        borderBottom: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        ...sx,
      }}
      {...props}
    />
  );
};

export default HorizontalLine;
